module.exports = __webpack_public_path__ + "img/computer4.c2d26af4.png";